import React from "react";
import { Typography } from "components";

const FormError = (props) => {
  return (
    <Typography variant="caption2" className="font-danger mt-1">
      {" "}
      {props.children}
    </Typography>
  );
};
export default FormError;
